//運航モード
const OPERATION_MODE = [
  { code: "N", label: "定常航海", icon: "sdf-track-vessel-15" },
  { code: "I", label: "内海", icon: "sdf-track-vessel-15" },
  { code: "K", label: "狭⽔道", icon: "sdf-vessel-gps" },
  { code: "P", label: "港内", icon: "sdf-vessel-gps" },
  { code: "B", label: "着岸", icon: "sdf-vessel-bridge" },
  { code: "U", label: "離岸", icon: "sdf-vessel-bridge" },
  { code: "A", label: "停泊", icon: "sdf-vessel-bridge" }
];

//操舵モード
const STEERING_MODE = [
  { code: "M", label: "Manual" },
  { code: "S", label: "Heading Control (Stand Alone)" },
  { code: "H", label: "Heading Control (External device)" },
  { code: "T", label: "Track Control" },
  { code: "R", label: "Rudder Control" },
  { code: "N", label: "NFU(Non Follow Up)" }
];

//操縦モード
const MANEUVERING_MODE = [
  { code: "K", label: "KICS" },
  { code: "D", label: "個別" },
  { code: "E", label: "外部操縦" },
  { code: "O", label: "オーバーライド" }
];

//操縦場所
const MANEUVERING_LOCATION = [
  { code: "A", label: "操舵室FU" },
  { code: "B", label: "操舵室NF" },
  { code: "C", label: "制御室FU" },
  { code: "D", label: "制御室NF" },
  { code: "E", label: "機側NF" },
  { code: "F", label: "右舷FU" },
  { code: "G", label: "左舷FU" },
  { code: "H", label: "KICS" },
  { code: "I", label: "SB-X" }
];

//SBX 運航モード
const SBX_OPERATION_MODE = [
  { code: "1", label: "定常航海" },
  { code: "2", label: "内海" },
  { code: "3", label: "狭⽔道" },
  { code: "4", label: "港内" }
];

// 変針方法
const SBX_VEERING_METHOD = [
  { code: "R", label: "半径一定" },
  { code: "T", label: "ターンレート一定" }
];

// 操船データ固定値
const MANEUVERING_ABBREVIATION = {
  SB21: {
    A: "操舵室FU",
    B: "操舵室NF",
    C: "制御室FU",
    D: "制御室NF",
    E: "機側NF",
    F: "右舷FU",
    G: "左舷FU",
    H: "KICS",
    I: "SB-X"
  },
  SB22: {
    A: "操舵室FU",
    B: "操舵室NF",
    C: "制御室FU",
    D: "制御室NF",
    E: "機側NF",
    F: "右舷FU",
    G: "左舷FU",
    H: "KICS",
    I: "SB-X"
  },
  SB29: {
    M: "Manual",
    S: "Heading Control (Stand Alone)",
    H: "Heading Control (External device)",
    T: "Track Control",
    R: "Rudder Control",
    N: "NFU (Non Follow Up)"
  },
  SB30: {
    K: "KICS",
    D: "個別",
    E: "外部操縦",
    O: "オーバーライド"
  },
  SB44: {
    N: "定常航海",
    I: "内海",
    K: "狭水道",
    P: "港内",
    B: "着岸",
    U: "離岸",
    A: "停泊"
  }
};

// 操船データ日本語チャンネル名
const MANEUVERING_JP_CHANNEL = [
  { code: "SB01", label: "年月日 時分秒" },
  { code: "SB02", label: "船位 緯度(高精度GPS)" },
  { code: "SB03", label: "船位 経度(高精度GPS)" },
  { code: "SB04", label: "対水速力(前後)" },
  { code: "SB05", label: "対地速力(高精度GPS)" },
  { code: "SB06", label: "対地針路(高精度GPS)" },
  { code: "SB07", label: "船位 緯度(GPS)" },
  { code: "SB08", label: "船位 経度(GPS)" },
  { code: "SB09", label: "対地速力(GPS)" },
  { code: "SB10", label: "対地針路(GPS)" },
  { code: "SB11", label: "船首方位(ジャイロコンパス)" },
  { code: "SB12", label: "回頭角速度(ジャイロコンパス)" },
  { code: "SB13", label: "水深(音響測探機)" },
  { code: "SB14", label: "相対風向" },
  { code: "SB15", label: "相対風速" },
  { code: "SB16", label: "ドリフト方位" },
  { code: "SB17", label: "ドリフト速度" },
  { code: "SB18", label: "針路指令値" },
  { code: "SB19", label: "船速指令値" },
  { code: "SB20", label: "オフトラック" },
  { code: "SB21", label: "右舷CPP操縦場所" },
  { code: "SB22", label: "左舷CPP操縦場所" },
  { code: "SB23", label: "右舷 No.1 主機回転数" },
  { code: "SB24", label: "右舷 No.2 主機回転数" },
  { code: "SB25", label: "左舷 No.1 主機回転数" },
  { code: "SB26", label: "左舷 No.2 主機回転数" },
  { code: "SB27", label: "右舷 CPP翼角" },
  { code: "SB28", label: "左舷 CPP翼角" },
  { code: "SB29", label: "操舵モード" },
  { code: "SB30", label: "操縦モード" },
  { code: "SB31", label: "現ジョイスティック操作量(前後進方向)" },
  { code: "SB32", label: "現ジョイスティック操作量(左右舷方向)" },
  { code: "SB33", label: "現回頭ダイアル操作量(左右舷方向)" },
  { code: "SB34", label: "現バウスラスタ操作量(左右舷方向)" },
  { code: "SB35", label: "現スタンスラスタ操作量(左右)" },
  { code: "SB36", label: "右舷 舵角" },
  { code: "SB37", label: "左舷 舵角" },
  { code: "SB38", label: "No.1 バウスラスタ翼角" },
  { code: "SB39", label: "No.2 バウスラスタ翼角" },
  { code: "SB40", label: "No.1 スランスラスタ翼角" },
  { code: "SB41", label: "No.2 スランスラスタ翼角" },
  { code: "SB42", label: "右舷 CPP翼角" },
  { code: "SB43", label: "左舷 CPP翼角" },
  { code: "SB44", label: "運航モード" },
  { code: "SB45", label: "船首部岸壁距離" },
  { code: "SB46", label: "船尾部岸壁距離" }
];

export default {
  data() {
    return {};
  },
  methods: {
    getOperationModeLabel(target) {
      if(!target) return "---";
      const result = OPERATION_MODE.find(({ code }) => code === target);
      return result.label;
    },
    getSBXOperationModeLabelByNumber(target) {
      if(!target) return "---";
      const result = SBX_OPERATION_MODE.find(({ code }) => code === target);
      return result.label;
    },
    getSteeringModeLabel(target) {
      if(!target) return "---";
      const result = STEERING_MODE.find(({ code }) => code === target);
      return result.label;
    },
    getVeeringMethodLabel(target) {
      if(!target) return "---";
      const result = SBX_VEERING_METHOD.find(({ code }) => code === target);
      return result.label;
    },
    getManeuveringModeLabel(target) {
      if(!target) return "---";
      const result = MANEUVERING_MODE.find(({ code }) => code === target);
      return result.label;
    },
    getManeuveringLocationLabel(target) {
      if(!target) return "---";
      const result = MANEUVERING_LOCATION.find(({ code }) => code === target);
      return result.label;
    },
    getManeuveringJapaneseChannelName(target) {
      if(!target) return "---";
      const result = MANEUVERING_JP_CHANNEL.find(({ code }) => code === target);
      return result.label;
    },
    getManeuveringAbbreviationMap() {
      return MANEUVERING_ABBREVIATION;
    },
    getIcon(target) {
      if(!target) return "sdf-track-vessel-15"
      const result = OPERATION_MODE.find(({ code }) => code === target);
      return result.icon;
    }
  }
};
